/**
 * Código QR generado EN EL NAVEGADOR — `TDS-CORE` DC-09 (alta de TOTP).
 *
 * El contenido es la URI `otpauth://` con el SECRETO del segundo factor. Por
 * eso nunca se usa un servicio de QR de terceros ni una imagen remota: eso
 * enviaría el secreto fuera. `qrcode-generator` (MIT, sin dependencias, versión
 * fijada) sólo calcula la matriz; aquí se pinta como SVG con elementos de
 * React, sin `innerHTML`.
 *
 * Siempre oscuro sobre claro, también en tema oscuro: muchas apps no leen un QR
 * invertido. Los colores salen de tokens (`OD-0017 D-02`).
 */
import qrcode from "qrcode-generator";

export function CodigoQr({ contenido, etiqueta }: { contenido: string; etiqueta: string }) {
  // Nivel M: tolera ~15 % de daño; suficiente en pantalla y más compacto que Q/H.
  const qr = qrcode(0, "M");
  qr.addData(contenido, "Byte");
  qr.make();
  const n = qr.getModuleCount();
  const margen = 4; // zona de silencio mínima del estándar

  let d = "";
  for (let fila = 0; fila < n; fila++) {
    for (let col = 0; col < n; col++) {
      if (qr.isDark(fila, col)) d += `M${col + margen} ${fila + margen}h1v1h-1z`;
    }
  }
  const lado = n + margen * 2;

  return (
    <svg
      className="codigo-qr"
      viewBox={`0 0 ${lado} ${lado}`}
      role="img"
      aria-label={etiqueta}
      shapeRendering="crispEdges"
    >
      <rect className="codigo-qr-fondo" width={lado} height={lado} />
      <path className="codigo-qr-celdas" d={d} />
    </svg>
  );
}
